import {Directive, ElementRef, HostListener} from '@angular/core';

@Directive({
  selector: '[gpClearCharactersInput]'
})
export class ClearCharactersInputDirective {

  private regexStr = /^[a-zA-Zéàèç0-9\- ]*$/;

  constructor(private el: ElementRef) {
  }

  @HostListener('keypress', ['$event'])
  public onKeyPress(event: KeyboardEvent) {
    return new RegExp(this.regexStr).test(event.key);
  }

  @HostListener('paste', ['$event'])
  public paste(event: ClipboardEvent) {
    setTimeout(() => {
      this.el.nativeElement.value = event.clipboardData.getData('text/plain')
        .replace(/[^A-Za-zéàèç0-9 -]/g, '').replace(/\s+/g, ' ');
      event.preventDefault();
    }, 0);
  }
}
